export interface CircleRoleLine {
  purpose: string
  roles: Array<{ name: string }>
}

/**
 * * Team-model list, one block per circle:
 * * "Cercle :\n\trôle 1, rôle 2 ;\nAutre :\n\trôle 3 ;"
 */
export function formatTeamCircles(circles: CircleRoleLine[]): string {
  if (circles.length === 0) {
    return ''
  }
  return circles.map((circle) => {
    const purpose = circle.purpose.trim() || 'Cercle'
    const roles = circle.roles.map((role) => role.name.trim()).filter((name) => name !== '')
    return `${purpose} :\n\t${roles.join(', ')} ;`
  }).join('\n')
}
